import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import DegradedBg from '../../../../assets/img/subscription/background-degraded-green.svg';
import ProjectIcon from '../../../../assets/img/subscription/projects.svg';
import AlertIcon from '../../../../assets/svg/AlertIcon';
import VehicleIcon from '../../../../assets/svg/subscription/VehicleIcon';
import { OrganizationResources } from '../../../../domain/resources/OrganizationResources';
import { Vehicle } from '../../../../domain/vehicle/Vehicle';
import Text from '../../../../react-components/Text';

const TextDivider = () => (
  <>
    <VSpacer medium />
    <div style={{ width: `100%`, height: `1px`, backgroundColor: `white` }} />
    <VSpacer medium />
  </>
);

type NewProjectSummaryContractProps = {
  step: number;
  vehicles: Vehicle[];
  resources: OrganizationResources;
};

export const NewProjectSummaryContract = ({ step, vehicles, resources }: NewProjectSummaryContractProps) => {
  return (
    <Grid
      container
      item
      alignItems="center"
      justifyContent="center"
      style={{ background: `url(${DegradedBg}) no-repeat`, backgroundSize: `cover`, width: `100%` }}
    >
      {(step === 0 && resources.exceedsProjectsHardLimit(1)) ||
      (step === 1 && resources.exceedsVehicleHardLimit(vehicles.length)) ? (
        <Grid display="flex" flexDirection="column" alignItems="center">
          <AlertIcon width="70px" height="70px" />
          <VSpacer medium />
          {step === 0 && resources.exceedsProjectsHardLimit(1) && (
            <Text
              variant="h6"
              style={{ color: RoutalPalette.white }}
              intlId="projects.create.summary.projects_exceeded"
            />
          )}
          {step === 1 && resources.exceedsVehicleHardLimit(vehicles.length) && (
            <Text
              variant="h6"
              style={{ color: RoutalPalette.white }}
              intlId="projects.create.summary.vehicles_exceeded"
            />
          )}
        </Grid>
      ) : (
        // Exceeds limit
        <Grid container direction="column" style={{ maxWidth: `640px`, padding: `0 20px` }}>
          <Text variant="h6" style={{ color: `white` }} intlId="projects.create.summary.title_contract" />

          <VSpacer large />

          <Grid item container direction="row">
            <Grid item xs={4}>
              <Text style={{ color: `white` }} intlId="projects.create.summary.item" />
            </Grid>

            <Grid item xs={4} container justifyContent="center">
              <Text style={{ color: `white` }} intlId="projects.create.summary.quantity" />
            </Grid>

            <Grid item xs={4} container justifyContent="flex-end">
              <Text style={{ color: `white` }} intlId="projects.create.summary.remaining" />
            </Grid>
          </Grid>

          <TextDivider />

          <Grid item container direction="row">
            <Grid item xs={4} container alignItems="center">
              <Grid item>
                <img width="24" src={ProjectIcon} alt="" draggable="false" />
              </Grid>

              <HSpacer small />

              <Grid item>
                <Text style={{ color: `white` }} intlId="projects.create.summary.projects" />
              </Grid>
            </Grid>

            <Grid item xs={4} container alignItems="center" justifyContent="center">
              <Text style={{ color: `white` }}>1</Text>
            </Grid>

            <Grid item xs={4} container alignItems="center" justifyContent="flex-end">
              <Text style={{ color: `white` }}>{`${Math.max(
                resources.subscription.projects - resources.getProjectsCount() - 1,
                0
              )}`}</Text>
            </Grid>
          </Grid>

          {step > 0 && vehicles.length > 0 ? (
            <>
              <TextDivider />

              <Grid item container direction="row">
                <Grid item xs={4} container alignItems="center">
                  <Grid item display={`flex`}>
                    <VehicleIcon style={{ height: `24px`, color: `white` }} />
                  </Grid>

                  <HSpacer small />

                  <Grid item>
                    <Text style={{ color: `white` }} intlId="projects.create.summary.vehicles" />
                  </Grid>
                </Grid>

                <Grid item xs={4} container alignItems="center" justifyContent="center">
                  <Text style={{ color: `white` }}>{vehicles.length}</Text>
                </Grid>

                <Grid item xs={4} container direction="row" wrap="nowrap" alignItems="center" justifyContent="flex-end">
                  <Text tagName="span" style={{ color: `white` }}>
                    {`${Math.max(resources.subscription.vehicles - resources.getVehicleCount() - vehicles.length, 0)}`}
                  </Text>
                </Grid>
              </Grid>
            </>
          ) : null}
        </Grid>
      )}
    </Grid>
  );
};
